//#region Icons
import PeopleIcon from "icons/PeopleIcon";
import OpenBookIcon from "icons/OpenBookIcon";
import StopIcon from "icons/StopIcon";
import TimerIcon from "icons/TimerIcon";
import EventIcon from "icons/EventIcon";
//#endregion
//#region Utils
import ABSOLUTE_PATHS from "routes/utils/absolutePaths";
import { TOOLTIP_PROPS } from "components/CardLinkItem/secondary/utils/constants";
import { PERMISSIONS_VIEWS } from "config/userPermissions";
import { onlySettingsModules } from "views/Configuracion/utils/constants";
//#endregion

const { CONFIG } = PERMISSIONS_VIEWS;

export const INFORMATION_LINKS = [
    {
        id: CONFIG.ADMIN_ROLES,
        title: "Administrador de Roles",
        icon: <PeopleIcon/>,
        to: ABSOLUTE_PATHS.SETTINGS_ROLE_ADMIN,
        tooltip: {
            message: "Asigna, edita o elimina roles.",
            props: {
                ...TOOLTIP_PROPS,
                maxSize: {
                    ...TOOLTIP_PROPS.maxSize,
                    x: "30%",
                    y: "-85%",
                    after: {
                        ...TOOLTIP_PROPS.maxSize.after,
                        x: "-78px",
                        y: "-25px"
                    }
                },
                minSize: {
                    ...TOOLTIP_PROPS.minSize,
                    x: "-70%",
                    after: {
                        ...TOOLTIP_PROPS.minSize.after,
                        x: "28px",
                        y: "0px"
                    }
                }
            }
        }
    },
    {
        id: CONFIG.ADMIN_ESPACIOS,
        title: "Administrador de Espacios",
        icon: <OpenBookIcon/>,
        to: ABSOLUTE_PATHS.SETTINGS_SPACE_ADMIN,
        tooltip: {
            message: "Registra los diferentes espacios dentro de cada campus.",
            props: {
                ...TOOLTIP_PROPS,
                maxSize: {
                    ...TOOLTIP_PROPS.maxSize,
                    width: "170px",
                    y: "-73%",
                    after: {
                        ...TOOLTIP_PROPS.maxSize.after,
                        x: "-93px",
                        y: "-35px"
                    }
                },
                minSize: {
                    ...TOOLTIP_PROPS.minSize,
                    x: "-75%",
                    y: "-170%",
                    width: "180px",
                    after: {
                        ...TOOLTIP_PROPS.minSize.after,
                        x: "50px",
                        y: "5px"
                    }
                }
            }
        }
    }, 
    {
        id: CONFIG.ADMIN_HORARIOS,
        title: "Administrador de Horarios",
        icon: <TimerIcon/>,
        to: ABSOLUTE_PATHS.SETTINGS_RESOURCE_SCHEDULE_ADMIN,
        tooltip: {
            message: "Registra los horarios de atención y días de no atención.",
            props: {
                ...TOOLTIP_PROPS,
                maxSize: {
                    ...TOOLTIP_PROPS.maxSize,
                    width: "170px",
                    after: {
                        ...TOOLTIP_PROPS.maxSize.after,
                        x: "-94px"
                    }
                },
                minSize: {
                    ...TOOLTIP_PROPS.minSize,
                    y: "-165%",
                    width: "165px",
                    after: {
                        ...TOOLTIP_PROPS.minSize.after,
                        x: "43px",
                        y: "6px"
                    }
                }
            }
        }
    }, 
    {
        id: CONFIG.ADMIN_SANCIONES,
        title: "Administrador de Sanciones",
        icon: <StopIcon/>,
        to: ABSOLUTE_PATHS.SETTINGS_RESOURCE_PENALTY_ADMIN,
        tooltip: {
            message: "Edita y elimina las sanciones asignadas a los alumnos.",
            props: {
                ...TOOLTIP_PROPS,
                maxSize: {
                    ...TOOLTIP_PROPS.maxSize,
                    x: "-110px",
                    y: "3px",
                    width: "150px",
                    after: {
                        ...TOOLTIP_PROPS.maxSize.after,
                        x: "38px",
                        y: "-66px",
                        angle: "225deg"
                    }
                },
                minSize: {
                    ...TOOLTIP_PROPS.minSize,
                    y: "-165%",
                    width: "150px",
                    after: {
                        ...TOOLTIP_PROPS.minSize.after,
                        x: "40px",
                        y: "6px"
                    }
                }
            }
        }
    },
    {
        id: CONFIG.ADMIN_FIRMAS_EVENTOS,
        title: "Administrador Firmas Eventos",
        icon: <EventIcon/>,
        to: ABSOLUTE_PATHS.SETTINGS_EVENT_SIGNATURE_ADMIN,
        tooltip: {
            message: "Configura las firmas disponibles para certificados de eventos por campus y vigencia.",
            props: {
                ...TOOLTIP_PROPS,
                maxSize: {
                    ...TOOLTIP_PROPS.maxSize,
                    width: "185px",
                    x: "-112px",
                    y: "8px",
                    after: {
                        ...TOOLTIP_PROPS.maxSize.after,
                        x: "42px",
                        y: "-69px",
                        angle: "225deg"
                    }
                },
                minSize: {
                    ...TOOLTIP_PROPS.minSize,
                    y: "-175%",
                    width: "180px",
                    after: {
                        ...TOOLTIP_PROPS.minSize.after,
                        x: "44px",
                        y: "7px"
                    }
                }
            }
        }
    }
].filter(onlySettingsModules);
